import { Platform } from 'react-native';

// Sesli aramanın açık/kapalı olması (9.4.13).
//
// Akışın tamamı yazılı ve ses gerçekten taşınabiliyor (D-087), ama bir ön koşul
// daha var: TURN sunucusu (9.4.4.2 — coturn). TURN'süz kurulum yalnız elverişli
// ağlarda (aynı LAN, basit NAT) çalışır; simetrik NAT ya da kurumsal ağda çağrı
// hiç kurulmaz. Ücret ise kabul anında işlemeye başlar (9.4.2.3), yani
// kurulamayan ya da sessiz bir çağrı için para almak riski gerçek.
//
// D-097 ile TURN + gerçek cihaz medyası uçtan uca doğrulandı; 9.4.13 kapandı.
// Bu yüzden arama mobilde artık varsayılan açık. Bayrak acil geri-kapama kapısıdır;
// Native WebRTC modülü yoksa ikinci kapı (`mediaAvailable`) butonu yine çizmez.
//
// D-855: the web has its own switch. Browser calls are not verified end to end,
// and every phone build and OTA sets EXPO_PUBLIC_CALLS_ENABLED=true, so that value
// reached web exports and opened calls there without a decision. The web opens
// only with EXPO_PUBLIC_WEB_CALLS_ENABLED=true, after its own verification.
const flag = process.env.EXPO_PUBLIC_CALLS_ENABLED;
const webFlag = process.env.EXPO_PUBLIC_WEB_CALLS_ENABLED;
export const callsEnabled = Platform.OS === 'web' ? webFlag === 'true' : flag !== 'false';

// Görüntülü aramanın giriş noktasının çizilip çizilmeyeceği (9.4.14).
//
// Sesli aramadan ayrı bir kapı, çünkü ön koşulu ayrı: görüntüyü çizen
// `CallVideo` web'de bilerek `null` döner (tarayıcıda akış `<video>`
// elementine bağlanır, o da RN'in JSX'inde yok). Web'de görüntülü aramayı
// açmak, kullanıcıdan görüntü ücreti alıp ekranda hiçbir şey göstermemek
// olurdu. Bu yüzden kapı `callsEnabled`'ın altına değil, yanına konuyor:
// sesli arama web'de açılabilir, görüntülü açılamaz.
export const videoCallsSupported = Platform.OS !== 'web';
